import { useCart } from '../../../contexts/CartContext';
import { products } from '../../../mocks/products';

export default function Products() {
  const { addToCart } = useCart();

  const handleAddToCart = (product: typeof products[0]) => {
    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      image: product.image,
      quantity: 1
    });
  };

  return (
    <section id="products" className="py-16 sm:py-20 md:py-24 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#2C2C2C] mb-3 sm:mb-4">
            精選花藝作品
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-4">
            每一束花都是獨特的藝術品，為您的重要時刻增添美好回憶
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8" data-product-shop>
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
            >
              <div className="relative overflow-hidden h-72 sm:h-80 w-full">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-3 sm:px-4 py-1.5 sm:py-2 rounded-full">
                  <span className="text-[#14B8A6] font-bold text-sm sm:text-base">
                    NT$ {product.price.toLocaleString()}
                  </span>
                </div>
              </div>

              <div className="p-5 sm:p-6">
                <h3 className="text-lg sm:text-xl font-bold text-[#2C2C2C] mb-2 sm:mb-3">
                  {product.name}
                </h3>
                <p className="text-xs sm:text-sm text-gray-600 mb-4 sm:mb-5 line-clamp-2 leading-relaxed">
                  {product.description}
                </p>

                <button
                  onClick={() => handleAddToCart(product)}
                  className="w-full bg-[#14B8A6] text-white py-2.5 sm:py-3 rounded-full font-semibold text-sm sm:text-base hover:bg-[#0F9B8E] transition-colors duration-300 whitespace-nowrap cursor-pointer"
                >
                  加入購物車
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
